<template>
    <div class="row">
        <div class="col-4">
            <file-preview :file="clip"></file-preview>
        </div>

        <div class="col">
            <div class="row">
                <div class="col h4">
                    {{ clip.created_at | dateAndTime }}
                </div>
            </div>
            <div class="row">
                <div class="col">
                    Innings: {{ clip.innings }}
                </div>
            </div>


            <div class="row mt-3">
                <div class="col">
                    {{ capitalise(clip.clipType) }}
                </div>
            </div>
            <div class="row">
                <div class="col" v-if="player">
                    {{ player.fullName }}
                </div>
                <div class="col" v-else>
                  Player ID Unknown
                </div>
            </div>

            <div class="row mt-3">
                <div class="col">
                    <download :fileID="clip.id" :gated="true" label="Download" btn-class="btn btn-secondary"></download>
                    <base-button
                      class="ml-2"
                      type="default"
                      :disabled="!selectedCollectionId || sendingToCollection"
                      @click="sendToCollection"
                    >
                      {{ sendingToCollection ? "Sending..." : "Send to Collection" }}
                    </base-button>
                </div>
                <!-- <button @click="kill(clip)">Kill</button> -->
            </div>
            <div class="row mt-2" v-if="linkedCollectionName">
              <div class="col small text-muted">
                Linked collection: {{ linkedCollectionName }}
              </div>
            </div>

        </div>
    </div>
</template>

<script>
import Download from "./Download";

export default {
    name: "Stream-Clip",
    components: {
      download: Download,
    },
    props: {
      clip: {
        type: Object,
        required: true,
      },
      selectedCollectionId: {
        type: String,
        default: "",
      },
      sendingToCollection: {
        type: Boolean,
        default: false,
      },
    },
    data() {
        return {

        };
    },
    computed: {
        linkedCollectionName() {
          if (!this.clip || !this.clip.colID) return "";
          const col = this.$store.getters["collections/byId"](this.clip.colID);
          return (col && col.name) || this.clip.colID;
        },
        player() {
            let p = this.$store.getters["players/byProp"]("ellipsePlayerId", this.clip.ellipseBatterId);
            if (!p) {
          this.$store.dispatch("players/fetchAndAdd", {
            where: [["ellipsePlayerId", "==", this.clip.ellipseBatterId]],
          });
        } return p
        }
    },

    methods: {
        capitalise(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        kill(file) {
      this.$store.dispatch("files/delete", file.id);
    },
    sendToCollection() {
      this.$emit("send-to-collection", this.clip);
    },
    }
}
</script>